import { eKeHoachKyActionsObj } from "../../action-types/ke-hoach/IKeHoachKyActions";
import { generateActions } from "../generateActions";

export const keHoachKyActions = {
  ...generateActions(eKeHoachKyActionsObj, "KE_HOACH_KY"),
};
